/**
 * Typdefinitioner för SimCardManagement
 * SIM-korthantering via Jasper API
 */

import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
  DevicePhoneMobileIcon,
  SignalSlashIcon,
} from '@heroicons/react/24/outline';

export interface SimCard {
  iccid: string;
  msisdn?: string;
  imei?: string;
  status?: string;
  ratePlan?: string;
  communicationPlan?: string;
  dateActivated?: string;
  usage?: {
    ctdDataUsage?: number;
    ctdSMSUsage?: number;
    ctdVoiceUsage?: number;
    ctdSessionCount?: number;
  };
}

export interface AggregatedUsage {
  totalDevices: number;
  activatedCount?: number;
  deactivatedCount?: number;
  otherCount?: number;
  totalDataUsageMB: number;
  totalDataUsageGB: number;
  totalSmsUsage: number;
  totalVoiceUsage: number;
  billingCycle: string;
  lastSync?: string;
  /** False tills summeringen av alla kort är klar. */
  usageIncluded?: boolean;
  /** True medan förbrukningen räknas i bakgrunden. */
  usagePending?: boolean;
  note?: string;
}

export interface RatePlan {
  id: string;
  name: string;
  description?: string;
  type?: string;
  status?: string;
}

export type SimTab = 'overview' | 'simcards' | 'reports';

// SIM-status konfiguration
export const SIM_STATUS_CONFIG: Record<string, { 
  label: string; 
  labelEn: string; 
  color: string; 
  bgColor: string; 
  icon: typeof CheckCircleIcon;
}> = {
  ACTIVATED: { 
    label: 'Aktiverad', 
    labelEn: 'Activated', 
    color: 'text-green-600', 
    bgColor: 'bg-green-100 dark:bg-green-900/30', 
    icon: CheckCircleIcon 
  },
  ACTIVATION_READY: { 
    label: 'Redo', 
    labelEn: 'Ready', 
    color: 'text-blue-600', 
    bgColor: 'bg-blue-100 dark:bg-blue-900/30', 
    icon: ClockIcon 
  },
  DEACTIVATED: { 
    label: 'Inaktiv', 
    labelEn: 'Inactive', 
    color: 'text-red-600', 
    bgColor: 'bg-red-100 dark:bg-red-900/30', 
    icon: XCircleIcon 
  },
  INVENTORY: { 
    label: 'Lager', 
    labelEn: 'Inventory', 
    color: 'text-textSecondary', 
    bgColor: 'bg-gray-100 dark:bg-gray-700', 
    icon: DevicePhoneMobileIcon 
  },
  RETIRED: { 
    label: 'Avslutad', 
    labelEn: 'Retired', 
    color: 'text-textTertiary', 
    bgColor: 'bg-gray-100 dark:bg-gray-700', 
    icon: SignalSlashIcon 
  },
  TEST_READY: { 
    label: 'Test', 
    labelEn: 'Test', 
    color: 'text-yellow-600', 
    bgColor: 'bg-yellow-100 dark:bg-yellow-900/30', 
    icon: ClockIcon 
  },
};
